import React, { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';


export function SaleListSearchInput() {

  const isPc = useContext(cmnContext).isPc;

  const {
    isLoading, isMoreReading,
    searchWord, setSearchWord,
    searchTypeList,
    chgAllSearchTypeFalse, chgAllSearchTypeDefault,
  } = useContext(SaleListContext);

  const inputRef = useRef<HTMLInputElement>(null);
  const inputWordRef = useRef<string>('');
  const [inputWord, setInputWord] = useState<string>(searchWord || '');
  // 初回表示の際のkeywordパラメータを有効にするため
  const prevTypeList = useRef(searchTypeList);


  // ホームアイコンタップ：検索ラベル初期化
  const onPressHome = () => {
    // 一番上にスクロール
    window.scrollTo({ top: 0 });
    // 入力を空に
    setSearchWord('');
    // (ランダム)searchTypeListをすべてfalse
    //chgAllSearchTypeFalse();
    // デフォルト表示に
    chgAllSearchTypeDefault();
  }

  // 検索されたら検索ワードが入力欄にも反映
  useEffect(() => {
    setInputWord(searchWord);
  }, [searchWord])

  // フォーカスでの入力補助表示
  const onFocus = () => {
  }


  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if(!isLoading && !isMoreReading) {
      const val = e.target.value;
      setInputWord(val);
      inputWordRef.current = val;
    }
  }

  // 検索開始
  const startSearch = () => {
    if(!isLoading && !isMoreReading) {
      const keyword = inputWordRef.current;
      setSearchWord(keyword);
      inputRef.current?.blur();
    }
  }

  // キーボードの改行
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // PC・スマホ共通
      if (e.key === "Enter") {
        e.preventDefault();
        // キーボードを閉じる
        inputRef?.current?.blur();
        // 検索開始
        startSearch();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);


  // 検索ラベルが変更になったら入力を空に
  useEffect(() => {
    if (JSON.stringify(prevTypeList.current) !== JSON.stringify(searchTypeList)) {
      prevTypeList.current = searchTypeList;
      setSearchWord('');
      setInputWord('');
    }
  }, [searchTypeList]);


  // 入力検索をリセット
  const clearInput = () => {
    setInputWord('');
    inputWordRef.current = '';
    setSearchWord('');
  };


  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'stretch',
        position: 'relative',
        width: '100%',
      }}
    >
      {/* 左のホームアイコン */}
      <i
        className="glyphicon glyphicon-home"
        onClick={onPressHome}
        style={{
          cursor: 'pointer',
          color: 'gray',
          fontSize: isPc? '28px' : '24px',
          borderRadius: '50%',
          paddingRight: '3px',
          marginRight: isPc? '6px' : '2px',
          marginLeft: isPc? '5px' : '0px',
          alignSelf: 'center',
        }}
      ></i>

      {/* 検索入力 */}
      <div style={{ position: 'relative', flex: 1 }}>
        <input
          ref={inputRef}
          type="text"
          value={inputWord}
          onChange={onInputChange}
          placeholder="例) 文法 / リスニング / 発音 / モチベーション"
          className='search_input'
          style={{
            width: '100%',
            fontSize: '16px',
            padding: inputWord //×ボタン分の右余白
              ? isPc
                ? '6px 36px 6px 12px'
                : '6px 36px 6px 6px'
              : isPc
                ? '6px 12px 6px 12px'
                : '6px 6px 6px 6px',
            boxSizing: 'border-box',
            border: 0,
          }}
        />

        {/* ×ボタン */}
        {inputWord && (
          <i
            className="glyphicon glyphicon-remove"
            onClick={clearInput}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#fff',
              backgroundColor: 'gray',
              fontSize: '10px',
              borderRadius: '50%',
              padding: '5px',
              zIndex: 10,
            }}
          ></i>
        )}
      </div>

      {/* 検索ボタン */}
      <span
        onClick={startSearch}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          padding: '6px 12px',
          backgroundColor: '#eee',
        }}
      >
        <span className="glyphicon glyphicon-search" style={{color: '#555555'}}></span>
      </span>
    </div>
  );
}